const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * 60;

/**
 * Checks if a given date string represents a date in the past or is invalid
 * @param dateISO - ISO date string to check
 * @returns true if the date is in the past or invalid, false otherwise
 */
export const isDateInPast = (dateISO: string): boolean => {
  const date = new Date(dateISO);
  const now = new Date();

  return isNaN(date.getTime()) || date <= now;
};

export interface CountdownUnits {
  hours: number;
  minutes: number;
  seconds: number;
}

/**
 * Calculates the countdown units from total seconds
 * @param seconds - Total seconds remaining
 * @returns CountdownTime object with days, hours, minutes, and seconds
 */
export const getCountdownUnits = (seconds: number): CountdownUnits => {
  const hours = Math.floor(seconds / SECONDS_PER_HOUR);
  const minutes = Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
  const secs = seconds % SECONDS_PER_MINUTE;

  return { hours, minutes, seconds: secs };
};

/**
 * Formats a CountdownTime object into a display string
 * @param countdown - CountdownTime object to format
 * @returns Formatted string (e.g., "2d 05h 30m" or "48h 30m")
 */
export const formatCountdown = (countdown: CountdownUnits): string => {
  const units: string[] = [];
  const hours = countdown.hours === 0 ? '0' : countdown.hours.toString().padStart(2, '0');
  const minutes = countdown.minutes === 0 ? '0' : countdown.minutes.toString().padStart(2, '0');

  units.push(`${hours}h`);
  units.push(`${minutes}m`);

  return units.join(' ');
};
